import {Component, ElementRef, Input, OnInit} from '@angular/core';
import {UserService} from '../../services/user.service';
import {UserMenuService} from './user-menu.service';
import {IsAuthorizedService} from '../../services/is-authorized.service';
import {CompanyModel} from '../../../../../projects/api/src/user/user.model';

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    standalone: false
})
export class UserMenuComponent implements OnInit {

  @Input() currentCompany: CompanyModel;

  public menu = {};
  public userDetails = this.userService;
  public sections = this.userMenuService.sections;
  public overlayIsOpen: boolean;

  public IsOpenUserConfigurations = false;

  public isAboutAppDialogOpen = false;

  constructor(private userService: UserService, private isAuthorizedService: IsAuthorizedService, private userMenuService: UserMenuService, private element: ElementRef) {
  }

  public clickedOutsideOverlay(event) {
    if (!this.element.nativeElement.contains(event.target)) {
      this.overlayIsOpen = false;
    }

  }

  public isAuthorized() {
    return this.isAuthorizedService.isAuthorized.getValue();
  }

  ngOnInit() {
    return;
  }

}
